import React, { useEffect } from 'react'
import { usePage } from '../../../../presentation/contexts/page'
import Home from '../../../../presentation/pages/dashboard/home'

// import { Container } from './styles'

const MakeHome = () => {
  const { setHeader } = usePage()

  useEffect(() => {
    (() => {
      setHeader({
        title: undefined,
        goTo: null,
      })
    })()
  }, [setHeader])

  return <Home />
}

export default MakeHome
